export enum CheckStyleKinds {
  Check = 0,
  Fill = 2,
}
